import {
  Module,
  VuexModule,
  Action,
  Mutation,
  getModule
} from 'vuex-module-decorators'
import Vue from 'vue'
import axios from 'axios'

import store from '@/store'
import dashboardModule from '@/store/dashboard'
import listModule, { ListType } from '@/store/list'
import whitelabelModule from '@/store/whitelabel'
import { User } from '@/types/User'
import { Whitelabel } from '@/types/Whitelabel'
import { isEmpty } from 'lodash'

const name = 'user'

@Module({
  namespaced: true,
  dynamic: true,
  name,
  store
})
class UserModule extends VuexModule {
  private allUsers: User[] = []

  private get whitelabel(): Whitelabel {
    return whitelabelModule.whitelabel
  }

  get users(): User[] {
    return this.allUsers
  }

  @Mutation
  setAllUsers(payload: User[]) {
    Vue.set(this, 'allUsers', payload)
  }

  @Action({ rawError: true })
  async fetchAll(params: {
    limit: number
    q?: string
    page?: number
    sortBy?: string
    sortDesc?: boolean
  }) {
    try {
      if (!isEmpty(listModule.allFilters[ListType.Unknown])) {
        Object.assign(params, {
          filter: listModule.allFilters[ListType.Unknown]
        })
      }

      const { data } = await axios.post(
        `/admin/${this.whitelabel.slug}/users`,
        params
      )
      this.context.commit('setAllUsers', data.users)
      return data.page_count
    } catch (error) {
      dashboardModule.newError('Nutzer konnten nicht geladen werden')
    }
  }

  @Action({ rawError: true })
  async delete(params: { userId: string }) {
    try {
      await axios.delete(
        `/admin/${this.whitelabel.slug}/users/${params.userId}`,
        {
          params
        }
      )
      this.fetchAll({ limit: listModule.perPage })
    } catch (error) {
      dashboardModule.newError('Nutzer konnten nicht gelöscht werden')
    }
  }
}

export default getModule(UserModule)
